import { useEffect, useRef } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export default function VideoPlayer({ source }) {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    const initializePlayer = () => {
      if (videoRef.current && !playerRef.current) {
        playerRef.current = videojs(videoRef.current, {
          controls: true,
          responsive: true,
          fluid: true,
          autoplay: 'muted',
          muted: true,
          techOrder: ['html5'],
          sources: [{
            src: source,
            type: 'application/x-mpegURL'
          }],
        });
      }
    };

    const timeoutId = setTimeout(initializePlayer, 100);
    
    return () => {
      clearTimeout(timeoutId);
      if (playerRef.current) {
        playerRef.current.dispose();
      }
    };
  }, [source]);

  useEffect(() => {
    const handleError = (error) => {
      console.error('Video Player Error:', error);
    };
  
    if (playerRef.current) {
      playerRef.current.on('error', handleError);
    }
    
    return () => {
      if (playerRef.current) {
        playerRef.current.off('error', handleError);
      }
    };
  }, []);

  return (
    <div className="h-100 w-100 bg-black">
      <div data-vjs-player className="h-100 w-100">
        <video 
          ref={videoRef} 
          className="video-js vjs-big-play-centered h-100 w-100"
          style={{ objectFit: 'contain' }}
          playsInline
          preload="auto"
        />
      </div>
    </div>
  );
}